<article class="comment" [class.comment--author]="isAuthor()">
  <header class="comment__header">
    <ocp-avatar
      [userInitials]="userInitials()"
      [colorSeed]="colorSeed()"
      size="md"
      fontWeight="bold"
    />
    <span class="comment__display-name">{{ displayName() }}</span>
  </header>

  @if (isAuthor() && showCloseButton()) {
    <button
      type="button"
      class="comment__close"
      [attr.aria-label]="'comment.close' | translate"
      (click)="onCloseClick()"
      (keydown)="onCloseKeydown($event)"
    ></button>
  }

  @if (date()) {
    <time class="comment__date">{{ date() | date: 'yyyy-MM-dd HH:mm' }}</time>
  }

  <p class="comment__text">{{ message() }}</p>

  @for (attachmentLink of attachmentLinks(); track attachmentLink.link) {
    <a
      class="comment__link-row"
      [href]="attachmentLink.link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span
        class="comment__attachment-link-icon"
        [attr.title]="'comment.attachment-link' | translate"
      ></span>
      <span class="comment__link-text" [title]="attachmentLink.name">{{
        attachmentLink.name
      }}</span>
    </a>
  }

  @for (hyperlink of hyperlinks(); track hyperlink.url) {
    <a class="comment__link-row" [href]="hyperlink.url" target="_blank" rel="noopener noreferrer">
      <span class="comment__link-icon" [attr.title]="'comment.hyperlink' | translate"></span>
      <span class="comment__link-text" [title]="hyperlink.url">{{ hyperlink.name }}</span>
    </a>
  }
</article>
